import axios from '@/server/request'

const state = {
    // 未读通知
    unreadNotice: {},
    // 所有通知
    notice: {}
}

const getters = {
    noticeNum: state => state.unreadNotice.iTotal
}

const mutations = {
    updateUnreadNotice(state, payload) {
        state.unreadNotice = null
        state.unreadNotice = payload
    },

    updateNotice(state, payload) {
        state.notice = null
        state.notice = payload
    }
}

const actions = {
    // 获取消息列表
    async fetchNotices({ commit }, params) {
        try {
            const res = await axios.get({
                url: 'notice/list',
                params
            })

            if (res.data.ErrorCode === 200) {
                if (params.iNoRead && params.iNoRead === 1) {
                    commit('updateUnreadNotice', res.data.Data)
                } else {
                    commit('updateNotice', res.data.Data)
                }
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    },

    // 标记消息已读
    async markNoticeReaded({ commit, dispatch }, params) {
        try {
            const res = await axios.post({
                url: 'notice/allRead',
                params
            })

            if (res.data.ErrorCode === 200) {
                dispatch('fetchNotices', { iNoRead: 1 })
            }
        } catch (errMsg) {
            console.error(errMsg)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
